import React, { useEffect, useState } from "react";
import { MyGuestListPopup } from "./MyGuestListPopup";
import OrderSummary from "./OrderSummary";
import CurrencyConverter from "./CurrencyConverter";
import StepTab from "./StepTab";
import { validateGuestForm } from "../../../../utils/formValidation";
import { sanitizeInput } from "../../../../utils/securityUtils";
import BillingForm from "./BillingForm";
import GuestDataForm from "./GuestDataForm";
import { isIOS } from "../../../../utils/iosdevice";

export function GuestDetailsForm({ handleNext, tabClass, activeTab }) {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [title, setTitle] = useState([]);
  const [selectedGuests, setSelectedGuests] = useState([]);

  let bookingData;
  if (typeof window !== "undefined" && window.sessionStorage) {
    bookingData = JSON.parse(sessionStorage.getItem("userBookingDetail"));
  }
  let userOrder;
  if (typeof window !== "undefined" && window.sessionStorage) {
    userOrder = JSON.parse(sessionStorage.getItem("userOrderSummary"));
  }
  let loginData;
  if (typeof window !== "undefined" && window.sessionStorage) {
    loginData = JSON.parse(sessionStorage.getItem("userLogin"));
  }
  let signUpData;
  if (typeof window !== "undefined" && window.sessionStorage) {
    signUpData = JSON.parse(sessionStorage.getItem("userSignup"));
  }
  // const loginData = JSON.parse(sessionStorage.getItem("userLogin"));
  // const signUpData = JSON.parse(sessionStorage.getItem("userSignup"));
  // const bookingData = JSON.parse(sessionStorage.getItem("userBookingDetail"));
  // const userOrder = JSON.parse(sessionStorage.getItem("userOrderSummary"));
  const [showPopup, setShowPopup] = useState(false);
  const [selfGuest, setSelfGuest] = useState(false);

  let formDetailsObj = {
    id: 0,
    title: "",
    title_text: "",
    first_name: "",
    last_name: "",
    gender: "",
    dob: "",
    passport: "",
    travelClass: "",
    age: "",
    pnr: "",
  };
  const [guestForms, setGuestForms] = useState([]);

  // const [guestForms, setGuestForms] = useState(
  //   Array.from({ length: parseInt(bookingData.adults) }, (_, i) => ({
  //     ...formDetailsObj,
  //     id: i + 1,
  //   }))
  // );
  const [errors, setErrors] = useState(
    Array.from({ length: parseInt(bookingData.adults) }, (_, i) => ({
      ...formDetailsObj,
      id: i + 1,
    }))
  );

  const [childForms, setChildForms] = useState(
    Array.from({ length: parseInt(bookingData.child) }, (_, i) => ({
      ...formDetailsObj,
      id: i + 1,
    }))
  );
  const [childErrors, setChildErrors] = useState(
    Array.from({ length: parseInt(bookingData.child) }, (_, i) => ({
      ...formDetailsObj,
      id: i + 1,
    }))
  );

  const [infantForms, setInfantForms] = useState(
    Array.from({ length: parseInt(bookingData.infant) }, (_, i) => ({
      ...formDetailsObj,
      id: i + 1,
    }))
  );
  const [infantErrors, setInfantErrors] = useState(
    Array.from({ length: parseInt(bookingData.infant) }, (_, i) => ({
      ...formDetailsObj,
      id: i + 1,
    }))
  );
  const [formData, setFormData] = useState({
    placard: {
      title: "",
      firstName: "",
      lastName: "",
      countryCode: "",
      Mobile: "",
    },
    billing: {
      title: "",
      firstName: loginData?.user?.first_name || "",
      lastName: loginData?.user?.last_name || "",
      countryCode: "",
      mobile: loginData?.user?.mobile || "",
      address: loginData?.user?.street || "",
      city: loginData?.user?.city || "",
      country: loginData ? `${loginData?.user?.country_id[0]}` : "",
      state: loginData ? `${loginData?.user?.state_id[0]}` : "",
      email: loginData?.user?.email || "",
      pincode: loginData?.user?.zip || "",
    },
    gst: {
      entityName: "",
      gstin: "",
    },
  });
  const [formDataError, setFormDataError] = useState({
    placard: {
      title: "",
      firstName: "",
      lastName: "",
      countryCode: "",
      Mobile: "",
    },
    billing: {
      title: "",
      firstName: "",
      lastName: "",
      countryCode: "",
      Mobile: "",
      address: "",
      city: "",
      country: "",
      state: "",
      pincode: "",
      email: "",
    },
  });

  const updateGuestForms = (index, field, value) => {
    const updatedForms = [...guestForms];
    updatedForms[index][field] = value;
    setGuestForms(updatedForms);
    const updatedErrors = [...errors];
    if (value.trim() !== "") {
      updatedErrors[index][field] = "";
    }
    setErrors(updatedErrors);
  };

  const handleUpdateChildData = (index, field, value) => {
    const updatedForms = [...childForms];
    updatedForms[index][field] = value;
    setChildForms(updatedForms);
    const updatedErrors = [...childErrors];
    if (value.trim() !== "") {
      updatedErrors[index][field] = "";
    }
    setChildErrors(updatedErrors);
  };

  const handleUpdateInfantData = (index, field, value) => {
    const updatedForms = [...infantForms];
    updatedForms[index][field] = value;
    setInfantForms(updatedForms);
    const updatedErrors = [...infantErrors];
    if (value.trim() !== "") {
      updatedErrors[index][field] = "";
    }
    setInfantErrors(updatedErrors);
  };

  const updatePlaCardField = (key, value, type = "text") => {
    const sanitized = sanitizeInput(value, type);
    setFormData((p) => ({ ...p, placard: { ...p.placard, [key]: sanitized } }));
    setFormDataError((p) => ({
      ...p,
      placard: { ...((p && p.placard) || {}), [key]: "" },
    }));
  };

  const updateBillingField = (key, value) => {
    if (key === "country") {
      const country = countries.find((item) => item.id === parseInt(value));
      // console.log("country",country)
      fetchState(country?.name);
    }
    if (key === "address") {
      const address = value;

      // ✅ Always update form data correctly
      setFormData((p) => ({ ...p, billing: { ...p.billing, [key]: address } }));

      // ✅ Empty value → no error
      if (!address) {
        setFormDataError((p) => ({
          ...p,
          billing: {
            ...((p && p.billing) || {}),
            [key]: "",
          },
        }));
        return;
      }

      // ❌ Prevent HTML tags
      if (/<[^>]*>/.test(address)) {
        setFormDataError((p) => ({
          ...p,
          billing: {
            ...((p && p.billing) || {}),
            [key]: "HTML tags are not allowed",
          },
        }));
        return;
      }

      // ❌ Disallow other special characters (allow / , . - #)
      if (!/^[a-zA-Z0-9\s.,!?'"()\-\/#]+$/.test(address)) {
        setFormDataError((p) => ({
          ...p,
          billing: {
            ...((p && p.billing) || {}),
            [key]: "Address cannot contain special characters.",
          },
        }));
        return;
      }

      // ✅ Clear error if valid
      setFormDataError((p) => ({
        ...p,
        billing: { ...((p && p.billing) || {}), [key]: "" },
      }));

      return;
    }

    if (key === "email") {
      const email = value.trim();
      const emailRegex = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

      setFormData((p) => ({ ...p, billing: { ...p.billing, [key]: email } }));

      // 🔹 No value → no error
      if (!email) {
        setFormDataError((p) => ({
          ...p,
          billing: { ...((p && p.billing) || {}), [key]: "" },
        }));
        return;
      }
      if (!emailRegex.test(email)) {
        setFormDataError((p) => ({
          ...p,
          billing: {
            ...((p && p.billing) || {}),
            [key]: "Invalid email format",
          },
        }));
      } else {
        setFormDataError((p) => ({
          ...p,
          billing: { ...((p && p.billing) || {}), [key]: "" },
        }));
      }

      return;
    }

    if (key === "state" || key === "city") {
      let finalValue = value;

      // If value contains letters, remove numbers
      if (/[A-Za-z]/.test(value)) {
        finalValue = value.replace(/\d/g, "");
      }

      setFormData((p) => ({
        ...p,
        billing: { ...p.billing, [key]: finalValue },
      }));

      // ✅ Clear error if valid
      setFormDataError((p) => ({
        ...p,
        billing: { ...((p && p.billing) || {}), [key]: "" },
      }));

      return;
    }

    setFormData((p) => ({ ...p, billing: { ...p.billing, [key]: value } }));
    setFormDataError((p) => ({
      ...p,
      billing: { ...((p && p.billing) || {}), [key]: "" },
    }));
  };

  const updateGstFields = (key, value, type = "text") => {
    const sanitized = sanitizeInput(value, type);
    setFormData((p) => ({ ...p, gst: { ...p.gst, [key]: sanitized } }));
  };

  const fetchCountry = async () => {
    const apiUrl = "/dial-api/encalm/details";

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const result = await response.json();
      if (result.status === "ok") {
        setTitle(result?.data?.salutation);
        const sortedCountries = [...(result?.data?.country || [])].sort(
          (a, b) => Number(a.phone_code) - Number(b.phone_code)
        );
        setCountries(sortedCountries);
      }
    } catch (error) {
      console.error("Error calling API:", error);
      throw error;
    }
  };

  const parseDOB = (dob) => {
    if (!dob) return null;

    // Case 1: YYYY-MM-DD (login)
    if (/^\d{4}-\d{2}-\d{2}$/.test(dob)) {
      const [year, month, day] = dob.split("-").map(Number);
      return new Date(year, month - 1, day);
    }

    // Case 2: DD-MM-YYYY (signup)
    if (/^\d{2}-\d{2}-\d{4}$/.test(dob)) {
      const [day, month, year] = dob.split("-").map(Number);
      return new Date(year, month - 1, day);
    }

    // Fallback (ISO / timestamp)
    const parsed = new Date(dob);
    return isNaN(parsed) ? null : parsed;
  };

  const handleSelfGuestAdd = (flag) => {
    setGuestForms((prevGuests) => {
      if (!prevGuests || prevGuests.length === 0) return prevGuests;

      let updatedFirstGuest;

      if (flag) {
        // Calculate age
        const dob = signUpData?.dateOfBirth || loginData?.user?.dob;

        const birthDate = parseDOB(dob);
        if (!birthDate) {
          console.error("Invalid DOB format:", dob);
          return;
        }

        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (
          monthDiff < 0 ||
          (monthDiff === 0 && today.getDate() < birthDate.getDate())
        ) {
          age--;
        }

        // console.log("age", age);

        updatedFirstGuest = {
          ...prevGuests[0], // preserve other fields like id
          class_type: "",
          gender: "",
          first_name: signUpData
            ? signUpData?.firstName
            : loginData.user.first_name,
          last_name: signUpData
            ? signUpData?.lastName
            : loginData.user.last_name,
          age: age,
          pnr_no: "",
          passport_no: "",
        };
      } else {
        updatedFirstGuest = {
          ...prevGuests[0],
          class_type: "",
          gender: "",
          first_name: "",
          last_name: "",
          age: "",
          pnr_no: "",
          passport_no: "",
        };
      }

      // Replace ONLY first guest
      return [updatedFirstGuest, ...prevGuests.slice(1)];
    });

    setSelfGuest(flag);
  };

  const fetchState = async (countryId) => {
    // console.log("countryId",countryId)
    const apiUrl = `/dial-api/encalm/states?country=${countryId}`;
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      const result = await response.json();
      // console.log("result",result)
      if (result.status === "ok") {
        setStates(result?.states);
      }
    } catch (error) {
      console.error("Error calling API:", error);
      throw error;
    }
  };

  // age calculation of selected guest
  const calculateAge = (dob) => {
    if (!dob) return "";

    const parts = dob.split("-");
    if (parts.length !== 3) return "";

    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const day = parseInt(parts[2], 10);

    const birthDate = new Date(year, month, day);
    if (isNaN(birthDate.getTime())) return "";

    const today = new Date();

    // ❌ DOB in future → invalid
    if (birthDate > today) return "";

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age >= 0 ? age : "";
  };

  useEffect(() => {
    fetchCountry();
  }, []);

  // guest form updation based on selected guest from my guest list
  useEffect(() => {
    const adultCount = parseInt(bookingData?.adults || 0);

    // CASE 1: No selected guests → show empty forms based on count
    if (!selectedGuests || selectedGuests.length === 0) {
      const emptyForms = Array.from({ length: adultCount }, (_, i) => ({
        ...formDetailsObj,
        id: i + 1,
      }));

      setGuestForms(emptyForms);
      return;
    }

    // CASE 2: Selected guests exist → prefill
    const filledForms = Array.from({ length: adultCount }, (_, i) => {
      const guest = selectedGuests[i];

      if (!guest) {
        // Extra empty slot if selectedGuests < adults
        return {
          ...formDetailsObj,
          id: i + 1,
        };
      }

      return {
        ...formDetailsObj,
        id: i + 1,
        title: "",
        title_text: "",
        first_name: guest.first_name || "",
        last_name: guest.last_name || "",
        gender: guest.gender || "",
        dob: guest.dob || "",
        passport: guest.passportNo || "",
        age: calculateAge(guest.dob),
      };
    });
    setGuestForms(filledForms);
  }, [bookingData.adults, selectedGuests]);

  useEffect(() => {
    if (loginData && loginData?.user?.country_id.length > 0) {
      fetchState(loginData?.user?.country_id[1]);
    }
  }, []);

  // console.log("loginData", loginData);
  // console.log("form", formData);

  return (
    <div>
      <CurrencyConverter totalAmount={userOrder?.totalAmount} />
      <div className="w-full px-[7vw] mt-[2vw] font-redhatRegular text-[#002C5F]">
        <StepTab tabClass={tabClass} activeTab={activeTab} />
      </div>
      <div className="flex flex-col xl:flex-row justify-between px-[7vw] py-6">
        <div className="w-[100%] xl:w-[60%] text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw] font-redhatRegular">
          {/* ------------------ Guest Details ------------------ */}
          <div>
            <h2 className="font-redhatBold mb-[1.2vw] text-primary text-[4vw] md:text-[2.5vw] xl:text-[1.5vw]">
              Guest Details
            </h2>
            <div className="flex items-center gap-2 mb-4">
              <input
                type="checkbox"
                checked={selfGuest}
                onChange={(e) => handleSelfGuestAdd(e.target.checked)}
                id="iamGuest"
                className="cursor-pointer"
              />
              <label
                htmlFor="iamGuest"
                className="text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]"
              >
                I am Guest
              </label>
              <span
                onClick={() => setShowPopup(true)}
                className="underline text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw] cursor-pointer"
              >
                My Guest List
              </span>
            </div>

            {/* Guest Details */}
            <div>
              <GuestDataForm
                title={title}
                forms={guestForms}
                updateFormsData={updateGuestForms}
                errors={errors}
                label="Guest"
              />
            </div>

            {/* Child Details Form */}
            {parseInt(bookingData?.child) > 0 && (
              <div className="mt-[2vw]">
                <h2 className="font-redhatBold border-b border-primary mb-[1.2vw] text-primary text-[4vw] md:text-[2.5vw] xl:text-[1.5vw]">
                  Child Details
                </h2>
                <GuestDataForm
                  title={title}
                  forms={childForms}
                  updateFormsData={handleUpdateChildData}
                  errors={childErrors}
                  label="Child"
                />
              </div>
            )}

            {/* Infant Details Form */}
            {parseInt(bookingData?.infant) > 0 && (
              <div className="mt-[2vw]">
                <h2 className="font-redhatBold border-b border-primary mb-[1.2vw] text-primary text-[4vw] md:text-[2.5vw] xl:text-[1.5vw]">
                  Infant Details
                </h2>
                <GuestDataForm
                  title={title}
                  label="Infant"
                  forms={infantForms}
                  updateFormsData={handleUpdateInfantData}
                  errors={infantErrors}
                />
              </div>
            )}
          </div>

          {/* ------------------ Placard Details ------------------ */}
          <div className="mt-10">
            <h2 className="font-redhatBold mb-[1.2vw] text-primary text-[4vw] md:text-[2.5vw] xl:text-[1.5vw]">
              Placard Details
            </h2>
            <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 mb-4">
              <div>
                <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                  Title*
                </label>
                <select
                  value={formData.placard.title}
                  onChange={(e) => updatePlaCardField("title", e.target.value)}
                  className={`w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] ${
                    isIOS ? "min-h-[44px]" : null
                  }  focus:outline-none focus:ring-0`}
                >
                  <option value="">Select</option>
                  {title &&
                    title?.map((el, ind) => (
                      <option key={el.id} value={`${el.id}-${el.name}`}>
                        {el.name}
                      </option>
                    ))}
                </select>
                {formDataError.placard.title && (
                  <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                    {formDataError.placard.title}
                  </p>
                )}
              </div>
              <div>
                <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                  First Name*
                </label>
                <input
                  value={formData.placard.firstName}
                  onChange={(e) =>
                    updatePlaCardField("firstName", e.target.value, "name")
                  }
                  type="text"
                  placeholder="Enter First Name"
                  maxLength={50}
                  className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
                />
                {formDataError.placard.firstName && (
                  <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                    {formDataError.placard.firstName}
                  </p>
                )}
              </div>
              <div>
                <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                  Last Name*
                </label>
                <input
                  value={formData.placard.lastName}
                  onChange={(e) =>
                    updatePlaCardField("lastName", e.target.value, "name")
                  }
                  type="text"
                  placeholder="Enter Last Name"
                  maxLength={50}
                  className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
                />
                {formDataError.placard.lastName && (
                  <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                    {formDataError.placard.lastName}
                  </p>
                )}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                  Country Code*
                </label>
                <select
                  value={formData.placard.countryCode}
                  onChange={(e) =>
                    updatePlaCardField("countryCode", e.target.value)
                  }
                  className={`w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] ${
                    isIOS ? "min-h-[44px]" : null
                  }  focus:outline-none focus:ring-0`}
                >
                  <option value="">Select</option>
                  {countries &&
                    countries?.map((el, ind) => {
                      return (
                        <option key={el.id} value={el.phone_code}>
                          {`+ ${el.phone_code}`}
                        </option>
                      );
                    })}
                </select>
                {formDataError.placard.countryCode && (
                  <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                    {formDataError.placard.countryCode}
                  </p>
                )}
              </div>
              <div>
                <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                  Mobile*
                </label>
                <input
                  value={formData.placard.mobile}
                  onChange={(e) =>
                    updatePlaCardField("mobile", e.target.value, "numeric")
                  }
                  type="text"
                  placeholder="Enter Mobile"
                  maxLength={15}
                  className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
                />
                {formDataError.placard.mobile && (
                  <p className="text-red-500 text-[3vw] md:text-[1.5vw] xl:text-[1vw] font-redhatRegular">
                    {formDataError.placard.mobile}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* ------------------ Billing Details ------------------ */}
          <BillingForm
            formData={formData}
            updateBillingField={updateBillingField}
            formDataError={formDataError}
            countries={countries}
            title={title}
            states={states}
          />

          {/* ------------------ Add GST Details ------------------ */}
          <div className="mt-[4vw] xl:mt-[2vw] mb-[4vw] xl:mb-[2vw]">
            <h2 className="font-redhatBold mb-[1.2vw] text-primary text-[4vw] md:text-[2.5vw] xl:text-[1.5vw]">
              Add GST Details
            </h2>
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
              <div>
                <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                  Entity Name (Optional)
                </label>
                <input
                  value={formData.gst.entityName}
                  onChange={(e) =>
                    updateGstFields("entityName", e.target.value, "name")
                  }
                  type="text"
                  placeholder="Enter Entity Name"
                  maxLength={100}
                  className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
                />
              </div>
              <div>
                <label className="font-redhatMedium text-primary text-[3.5vw] md:text-[2.2vw] xl:text-[1.1vw]">
                  GSTIN (Optional)
                </label>
                <input
                  value={formData.gst.gstin}
                  onChange={(e) =>
                    updateGstFields("gstin", e.target.value, "text")
                  }
                  type="text"
                  placeholder="Enter GSTIN"
                  maxLength={15}
                  className="w-full border border-primary text-primary rounded-md px-[1.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] mt-[0.5vw] outline-none"
                />
              </div>
            </div>
          </div>

          <MyGuestListPopup
            isOpen={showPopup}
            onClose={() => setShowPopup(false)}
            setSelectedGuests={setSelectedGuests}
            selectedGuests={selectedGuests}
            guestCount={bookingData?.adults}
            title={title}
            customerId={
              signUpData?.customerId
                ? signUpData?.customerId
                : loginData?.customerId
            }
          />
        </div>
        {/* Order Summary */}
        <div className="w-[100%] xl:w-[35%]">
          <OrderSummary
            data={userOrder?.product}
            addonCart={userOrder?.addon}
            bookingData={bookingData}
            handleNext={handleNext}
            nextStep={"Checkout"}
            formData={{
              billingFormData: formData,
              guest: guestForms,
              child: childForms,
              infant: infantForms,
              user: loginData ? loginData : signUpData,
            }}
            setErrors={{
              billingErrors: setFormDataError,
              guestErrors: setErrors,
              childErrors: setChildErrors,
              infantErrors: setInfantErrors,
            }}
          />
        </div>
      </div>
    </div>
  );
}
